import { AccountSummary } from './account-summary';

export interface AccountSummaryList {
  nextPage: number;
  totalRows: number;
  accounts: AccountSummary[];
}
